<adsense ad-client="ca-pub-8459277046412894" ad-slot="5423811324" ad-style="display:block" ad-format="auto"></adsense>